import React, { useEffect, useState } from 'react';
import { AppButton, AppInput } from '@pro-sto/ui';
import { validateTemplateName } from '@/stores/shiftTemplateModel';
import './ShiftTemplateNameDialog.css';

interface ShiftTemplateNameDialogProps {
  isOpen: boolean;
  isSaving?: boolean;
  onSave: (name: string) => void;
  onCancel: () => void;
}

export const ShiftTemplateNameDialog: React.FC<ShiftTemplateNameDialogProps> = ({
  isOpen,
  isSaving = false,
  onSave,
  onCancel,
}) => {
  const [name, setName] = useState('');
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!isOpen) return;
    setName('');
    setError(null);
  }, [isOpen]);

  if (!isOpen) return null;

  const handleSave = () => {
    const validationError = validateTemplateName(name);
    if (validationError) {
      setError(validationError);
      return;
    }
    onSave(name.trim());
  };

  return (
    <div
      className="shift-template-name-dialog-overlay"
      onClick={(event) => {
        if (event.target === event.currentTarget && !isSaving) onCancel();
      }}
    >
      <div
        className="shift-template-name-dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby="shift-template-name-dialog-title"
        data-testid="shift-template-name-dialog"
      >
        <h2
          id="shift-template-name-dialog-title"
          className="shift-template-name-dialog__title"
        >
          Имя шаблона
        </h2>
        <div className="shift-template-name-dialog__field">
          <AppInput
            value={name}
            placeholder="Введите имя"
            onChange={(value) => {
              setName(value);
              if (error) setError(null);
            }}
            error={Boolean(error)}
            disabled={isSaving}
            data-testid="shift-template-name-input"
          />
          {error ? (
            <p className="shift-template-name-dialog__error" data-testid="shift-template-name-error">
              {error}
            </p>
          ) : null}
        </div>
        <div className="shift-template-name-dialog__actions">
          <AppButton
            variant="secondary"
            onClick={onCancel}
            disabled={isSaving}
            data-testid="shift-template-name-cancel"
          >
            Отменить
          </AppButton>
          <AppButton
            variant="primary"
            onClick={handleSave}
            loading={isSaving}
            data-testid="shift-template-name-save"
          >
            Сохранить
          </AppButton>
        </div>
      </div>
    </div>
  );
};

ShiftTemplateNameDialog.displayName = 'ShiftTemplateNameDialog';

export default ShiftTemplateNameDialog;
